export const OptionValues = {
  DELETE_INSPECTIONS: "delete_inspections",
  ASSIGN_TO_USER: "assign_to_user",
};

export const AssignOption = {
  ASSIGN_TO_ANOTHER_USER: "assign_to_another_user",
  ASSIGN_TO_ORG_ADMIN: "assign_to_org_admin",
};
